// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","loadingContainer":"App_loadingContainer__HttAr","mainCard":"App_mainCard__x-WyL"};